// extracted by mini-css-extract-plugin
module.exports = {"CompImgTextCountdown":"CompImgTextCountdown_CompImgTextCountdown__xoXSb"};